module.exports = __webpack_public_path__ + "img/report-default.a756f6f8.svg";